module.exports = __webpack_public_path__ + "img/3_ua.96388b7d.jpg";